import React, { useEffect, useState } from 'react';
import {
  theme,
  ChakraProvider,
  Flex,
  Image,
  Button,
  Text,
  Link,
} from '@chakra-ui/react';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import LoaderIcon from '../assets/img/loader_img.svg';
import CloseIcon from '../assets/img/close.svg';
import RejectSelfieCard from './RejectSelfieCard';
import { makeExistingUserGuest, updateSelfie } from '../apis/User';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useHistory } from 'react-router';

const CameraCard = props => {
  const [dataUri, setDataUri] = useState('');
  const [showReject, setShowReject] = useState(false);
  const [userImage, setUserImage] = useState(null);
  const userProfile = useStoreState(state => state.userProfile);
  const eventDetails = useStoreState(state => state.eventDetails);
  const handleTempUser = useStoreActions(store => store.handleTempUser);
  const handleUserProfile = useStoreActions(store => store.handleUserProfile);
  const handleEventDetails = useStoreActions(store => store.handleEventDetails);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showbtn, setShowBtn] = useState(false);
  const isUserLogged = useStoreState(state => state.isUserLogged);
  const { id } = props.match.params;
  const redirectBack = window.location.pathname.split('=')[1];
  const history = useHistory();
  var lastindex = window.location.pathname.lastIndexOf('/');
  let eventId = !isUserLogged ? id : window.location.pathname.split('/')[6]; //!isUserLogged ? window.location.pathname.split('/')[2] : window.location.pathname.split('/')[4]
  console.log('eventID ps', eventId);

  if (typeof eventId === 'undefined'){
    eventId = window.location.pathname.substring(lastindex + 1);
    console.log('eventID ps inside undefined', eventId);
  }
  
 

  const showRejectSelfieBtn = () => {
    showReject === false ? setShowReject(true) : setShowReject(false);
  };

  const handleTakePhoto = dataUri => {
    // Do stuff with the photo...
    setShowBtn(true);
    console.log('takePhoto', dataUri);
    setDataUri(dataUri);
  };

  const handleCameraError = error => {
    console.log('handleCameraError', error);
  };

  const handleCameraStart = stream => {
    console.log('handleCameraStart');
  };

  const handleCameraStop = () => {
    console.log('handleCameraStop');
  };

  const handleTakePhotoAnimationDone = dataUri => {
    setShowBtn(true);
    console.log('takePhoto', dataUri);
    setDataUri(dataUri);
  };

  const handleReTakePhoto = () => {
    setDataUri('');
    setShowBtn(false);
  };

  const handleSelectTakePhoto = () => {
    sendSelfie(dataUri);
  };

  useEffect(() => {
    if (navigator.getUserMedia) {
      navigator.getUserMedia(
        { audio: true, video: { width: 1280, height: 720 } },
        function (stream) {
          var video = document.querySelector('video');
          video.srcObject = stream;
          video.onloadedmetadata = function (e) {
            video.play();
          };
        },
        function (err) {
          console.log('The following error occurred: ' + err.name);
        }
      );
    } else {
      console.log('getUserMedia not supported');
    }
  }, []);

  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr?.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  function sendSelfie(imageUri) {
    var userImage = dataURLtoFile(
      imageUri,
      `${new Date().toDateString().split(' ').join('')}.jpg`
    );
    setUserImage(userImage);

    updateSelfie(userProfile.api_key, eventId, userImage).then(response => {
      if (!response.error) {
        if (isUserLogged) {
          makeExistingUserGuest(
            userProfile.api_key,
            eventId,
            response.data[0]['selfi_url']
          ).then(response => {
            if (!response.error) {
              handleEventDetails(response.data[0]);
              handleUserProfile(response.user_data[0]);
              if (!id) {
                history.replace(`${id ? id : redirectBack}`);
              } else {
                history.replace(`${process.env.PUBLIC_URL}/showroom/${id}`);
              }
            } else {
              setErrorMessage(response.message);
              showRejectSelfieBtn();
            }
          });
        } else {
          handleTempUser(response.data[0]);
          if (!id) {
            history.replace(`${id ? id : redirectBack}`);
          } else {
            history.replace(`${process.env.PUBLIC_URL}/showroom/${id}`);
          }
        }
      } else {
        setErrorMessage(response.message);
        showRejectSelfieBtn();
      }
    });
  }

  return (
    <ChakraProvider theme={theme}>
      <Flex
        alignItems="center"
        justifyContent="center"
        w="100vW"
        height="100vH"
        zIndex="910"
        bg="black"
        flexDirection="column"
      >
        <Flex
          className="ps-desktop-camera-cross"
          position="fixed"
          top="6"
          left="5"
          zIndex="912"
        >
          <Image
            src={CloseIcon}
            onClick={() => history.goBack()}
            alt="Loader Icon"
            w="4"
            h="4"
          />
        </Flex>

        {dataUri ? (
          <Flex mt="-10">
            <Image
              src={dataUri}
              h="250px"
              w="250px"
              borderRadius="200px"
              objectFit="cover"
              onClick={() => handleTakePhotoAnimationDone(dataUri)}
            />
          </Flex>
        ) : (
          <Flex mt="-10">
            <Camera
              onTakePhoto={dataUri => {
                handleTakePhoto(dataUri);
              }}
              onTakePhotoAnimationDone={dataUri => {
                handleTakePhotoAnimationDone(dataUri);
              }}
              onCameraError={error => {
                handleCameraError(error);
              }}
              idealFacingMode={FACING_MODES.USER}
              imageType={IMAGE_TYPES.JPG}
              isMaxResolution={false}
              idealResolution={{ width: 440, height: 400 }}
              isImageMirror={true}
              isSilentMode={false}
              isDisplayStartCameraError={true}
              isFullscreen={false}
              sizeFactor={1}
              onCameraStart={stream => {
                handleCameraStart(stream);
              }}
              onCameraStop={() => {
                handleCameraStop();
              }}
            />
          </Flex>
        )}
        {showbtn && (
          <Flex
            className="ps-desktop-width-50-per"
            alignItems="center"
            justifyContent="space-between"
            position="fixed"
            zIndex="912"
            bottom="0"
            w="90%"
            mb="4"
          >
            <Button
              bg="black"
              color="white"
              fontSize="14px"
              onClick={() => handleReTakePhoto()}
            >
              Retake
            </Button>
            <Button
              bg="white"
              borderRadius="40"
              pl="6"
              pr="6"
              color="#FA2F45"
              fontSize="14px"
              fontWeight="400"
              onClick={() => handleSelectTakePhoto()}
            >
              Select
            </Button>
          </Flex>
        )}
      </Flex>

      <Flex
        display="none"
        w="100vW"
        h="100vh"
        position="fixed"
        zIndex="912"
        alignItems="center"
        justifyContent="center"
      >
        <Flex
          bg="white"
          p="4"
          pl="8"
          pr="9"
          borderRadius="20"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
        >
          <Image src={LoaderIcon} alt="Loader Icon" w="10" h="10" />
          <Text pt="2" color="#000000" fontSize="15px" fontWeight="400">
            Finding your pics
          </Text>
        </Flex>
      </Flex>

      {showReject && (
        <RejectSelfieCard
          image={dataUri}
          error={errorMessage}
          ClickAgain={showRejectSelfieBtn}
        />
      )}
    </ChakraProvider>
  );
};

export default CameraCard;
